module.exports = __webpack_public_path__ + "static/select-square-fcc0095ceca66fdcec23c2856703873c.png";